// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContentBuilder__figcaption{color:#606060;font-style:italic}@media(min-width:768px){.ContentBuilder__row{display:flex;flex-direction:row;flex-wrap:wrap}.ContentBuilder__row--center{justify-content:center}.ContentBuilder__row--columns{flex-basis:0;flex-direction:column;flex-grow:1}.ContentBuilder__row--columns+.ContentBuilder__row--columns{margin-left:2rem}}.ContentBuilder__imageFigure{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
